<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-market-select
            v-model="filter.marketId"
            init-value
            :clearable="false"
            width="130px"
        ></gj-market-select>
        <gj-search-input
            v-model="filter.query"
            width="180px"
            placeholder="搜索词"
        ></gj-search-input>
        <gj-search-input
            v-model="filter.asin"
            width="180px"
            placeholder="搜索ASIN"
        ></gj-search-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            tooltip="数据时间"
            :clearable="false"
            :max-day-length="180"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-checkbox
          v-model="filter.filterAdZero"
          @input="$gjNoticeQuery">
        <span style="color: #666">过滤广告业绩为0的数据</span>
      </gj-checkbox>
    </template>
    <template #tool-group>
      <gj-tool-group
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="searchAdAnalysis"
          :loading="loading"
          size="has-picture"
          :data="tableData"
          :columns="columns"
          expand
          show-summary
          :show-overflow="false"
          :expandTableAttrs="{ 'span-method': spanMethod }"
          :expand-lazy-load="expandLazyLoad"
          :pagination="pagination"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:query="{row}">
          <gj-link :href="row.amazonUrl" target="_blank">{{row.query | defaultShow}}</gj-link>
        </template>
        <template v-slot:analysis="{row}">
          <gj-button
              type="text"
              @click="analysis(row)"
              style="font-size: 21px;">
            <gj-icon iconfont="iconshuju1"></gj-icon>
          </gj-button>
        </template>
        <template v-slot:expand:query="{row}">
          <div v-gutter="8">
            <app-ad-route-link
                :market-id="row.marketId"
                :type="AdTypeEnum.SP"
                :campaign="row">
              {{row.campaignName}}
            </app-ad-route-link>
            <span>[ 商品广告 ]</span>
            <span>&gt;</span>
            <app-ad-route-link
                :market-id="row.marketId"
                :type="AdTypeEnum.SP"
                :campaign="row"
                :group="row"
                :group-targeting-type="AdGroupEnum.SP.targetingType.KEYWORD">
              {{row.groupName}}
            </app-ad-route-link>
            <span :style="{color: row.servingStatus === 'OUTOFBUDGET' || row.servingStatus === 'OUT_OF_BUDGET' ? 'red' : ''}">
              [ {{row.servingStatus | optionText(AdCampaignEnum.SP.servingStatusOption) | defaultShow('', '', '广告活动已暂停')}} ]
            </span>
          </div>
          <div v-gutter="8" style="margin-top: 2px;">
            <gj-tag :color="row.matchType | optionColor(AdKeywordEnum.SP.matchTypeOption)">
              {{row.matchType | optionText(AdKeywordEnum.SP.matchTypeOption)}}
            </gj-tag>
            <span>
              <span style="color: #888;">默认竞价：</span>
              <span>{{row.bid | defaultShow(row.currencySymbol)}}</span>
            </span>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../common/fields";
  import AppAdSearchKeywordRelateAsinModal from "./modal/ad-search-keyword-relate-asin-modal";
  import {queryMixin} from "../../../../../minxins";
  import {subDays} from 'date-fns';
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {convertToDate} from "../../../../../utils/date.util";
  import {getAdsSearchKeywordPerformancePage, getAdsSearchKeywordPerformanceSearchKeyword} from "../../../../../api/ad";
  import {AdCampaignEnum, AdGroupEnum, AdKeywordEnum, AdTypeEnum} from "../../common/enum";
  import {getMarket} from "../../../../../api/common";
  import {adDefaultSortMixin, currencySymbolMixin} from "../../common/mixin";
  import AppAdRouteLink from "../../common/components/app-ad-route-link";

  export default {
    name: "app-ad-search-word-analysis",
    components: {AppAdRouteLink},
    mixins: [queryMixin, currencySymbolMixin, adDefaultSortMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'query', header: '搜索词信息', field: 'slot:query', minWidth: '300px', fixed: 'left', copyable: true},
          {id: 'analysis', header: '关联ASIN', field: 'slot:analysis', minWidth: '100px', fixed: 'left'},
          adFields.impressions,
          adFields.clicks,
          adFields.ctr,
          adFields.cost,
          adFields.cpc,
          adFields.orders,
          adFields.cvr,
          adFields.cpa,
          adFields.sales,
          adFields.acos,
          adFields.roas
        ],
        filter: {
          marketId: null,
          query: null,
          asin: null,
          date: [subDays(new Date(), 6), new Date()],
          filterAdZero: false,
        },
        AdTypeEnum: AdTypeEnum,
        AdCampaignEnum: AdCampaignEnum,
        AdGroupEnum: AdGroupEnum,
        AdKeywordEnum: AdKeywordEnum,
        initMarketId: null,
        currencySymbol: '',
        cacheOptions: {
          useCache: true,
        }
      }
    },
    created() {
      /*this.sort.prop = 'impressions';*/
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            marketId: this.filter.marketId,
            query: null,
            asin: null,
            date: [subDays(new Date(), 6), new Date()],
            filterAdZero: true,
          }
        };
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{marketId: *}}
       */
      $gjCacheCallback(params) {
        return {
          marketId: params.marketId
        };
      },
      $gjQuery() {
        if (isMeaningless(this.filter.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            marketId: this.filter.marketId,
            dataType: this.filter.filterAdZero ? 1 : 0,
            query: defaultVal(this.filter.query, null),
            asin: defaultVal(this.filter.asin, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getMarket(this.filter.marketId)
          .then((market) => {
            this.currencySymbol = market.currencySymbol;
            return Promise.resolve(market.currencySymbol);
          })
          .then((currencySymbol) => {
            return getAdsSearchKeywordPerformancePage(params)
              .then((data) => {
                if (isMeaningful(data)) {
                  this.tableData = this.currencySymbolMixin(data.records, currencySymbol);
                  this.pagination = this.getPagination(data);
                } else {
                  this.tableData = [];
                }
              })
          })
          .complete(() => {
            this.loading = false;
          });
      },
      analysis(row) {
        this.$gjCreate(AppAdSearchKeywordRelateAsinModal, {
          props: {
            marketId: this.filter.marketId,
            currencySymbol: this.currencySymbol,
            item: row,
            queryDate: this.filter.date
          }
        });
      },
      expandLazyLoad(row, index, resolve) {
        getAdsSearchKeywordPerformanceSearchKeyword({
          ...this.globalParams.model,
          query: row.query
        })
          .then((data) => {
            resolve(this.currencySymbolMixin(data || [], this.currencySymbol));
          })
          .catch(() => {
            resolve([]);
          });
      },
      spanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 2
          };
        } else if (columnIndex === 2) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .operate-group{
     margin: 6px 0 7px 0;
  }
  /deep/ .gj-table .gj-help--icon .gj-icon{
    color: #999;
  }
</style>

